//
//
import { call, put, takeEvery } from "redux-saga/effects"

import {
  CONTROLESCOLAR_LISTA_ALUMNOS,
  CONTROLESCOLAR_GET_PERSONA,
  CONTROLESCOLAR_PUT_PERSONA,
  CONTROLESCOLAR_SEND_PASSWORD,
  CONTROLESCOLAR_POST_PHOTO,
  CONTROLESCOLAR_PUT_ODIRECCION,
  CONTROLESCOLAR_GET_ALUMNO,
  CONTROLESCOLAR_PUT_ALUMNO,
  CONTROLESCOLAR_GET_EMAIL,
  CONTROLESCOLAR_GET_CURP,
  CONTROLESCOLAR_GET_DESCUENTOS_INSCRIPCION,
  CONTROLESCOLAR_CREATE_ALUMNO,
} from "./actionTypes"

import {
  getControlEscolarListaAlumnosSuccess,
  getControlEscolarListaAlumnosFail,
  getControlEscolarGetPersonaSuccess,
  getControlEscolarGetPersonaFail,
  putControlEscolarPutPersonaSuccess,
  putControlEscolarPutPersonaFail,
  postControlEscolarSendPasswordSuccess,
  postControlEscolarSendPasswordFail,
  postControlEscolarUploadPhotoSuccess,
  postControlEscolarUploadPhotoFail,
  putControlEscolarPutoDireccionSuccess,
  putControlEscolarPutoDireccionFail,
  getControlEscolarGetAlumnoSuccess,
  getControlEscolarGetAlumnoFail,
  putControlEscolarPutAlumnoSuccess,
  putControlEscolarPutAlumnoFail,
  getControlEscolarGetEmailSuccess,
  getControlEscolarGetEmailFail,
  getControlEscolarGetCurpSuccess,
  getControlEscolarGetCurpFail,
  getControlEscolarDescuentosInscripcionSuccess,
  getControlEscolarDescuentosInscripcionFail,
  postControlEscolarCreateAlumnoSuccess,
  postControlEscolarCreateAlumnoFail,
  setControlEscolarResponseParametros,
} from "./actions"

import {
  getListaAlumnos,
  get_From_PersonaController,
  put_From_PersonaController,
  post_From_PhotoControllerworking,
  post_To_FileController,
  get_From_ControlEscolarController,
  post_To_ControlEscolarController,
  put_To_ControlEscolarController,
  del_From_ControlEscolarController,
  get_From_AlumnoController,
  post_To_AlumnoController,
  put_To_AlumnoController,
  del_From_AlumnoController,
} from "../../helpers/campusvirtualbackend_helper"
//
function* fetchPutoDireccion({ payload: { jsonparameters } }) {
  try {
    const response = yield call(put_To_ControlEscolarController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(putControlEscolarPutoDireccionFail(response.Mensaje_Detalle))
    } else {
      yield put(putControlEscolarPutoDireccionSuccess(response.Datos[0]))
    }
  } catch (error) {
    yield put(putControlEscolarPutoDireccionFail(error))
  }
}
function* fetchPutAlumno({ payload: { jsonparameters } }) {
  try {
    const response = yield call(put_To_ControlEscolarController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(putControlEscolarPutAlumnoFail(response.Mensaje_Detalle))
    } else {
      yield put(putControlEscolarPutAlumnoSuccess(response.Datos))
    }
  } catch (error) {
    yield put(putControlEscolarPutAlumnoFail(error))
  }
}
function* fetchPostPhoto({ payload: { jsonparameters, formData } }) {
  try {
    const response = yield call(
      post_To_FileController,
      jsonparameters,
      formData
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(postControlEscolarUploadPhotoFail(response.Mensaje_Detalle))
    } else {
      //console.log(response.Datos[0])
      yield put(postControlEscolarUploadPhotoSuccess(response.Datos[0]))
    }
  } catch (error) {
    yield put(postControlEscolarUploadPhotoFail(error))
  }
}
function* fetchPostPhotoworking({ payload: { formData } }) {
  try {
    console.log("formData:", formData)
    // for (let [key, value] of formData.entries()) {
    //   if (key === "file") {
    //     hasFile = true
    //     console.log("value:", value)
    //     break
    //   }
    // }
    const response = yield call(post_From_PhotoControllerworking, formData)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(postControlEscolarUploadPhotoFail(response.Mensaje_Detalle))
    } else {
      yield put(postControlEscolarUploadPhotoSuccess(response.Photos))
    }
  } catch (error) {
    yield put(postControlEscolarUploadPhotoFail(error))
  }
}
function* fetchSendPassword({ payload: { jsonparameters } }) {
  try {
    const response = yield call(post_From_PersonaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(postControlEscolarSendPasswordFail(response.Mensaje_Detalle))
    } else {
      yield put(postControlEscolarSendPasswordSuccess(response.Datos))
    }
  } catch (error) {
    yield put(postControlEscolarSendPasswordFail(error))
  }
}
function* fetchPutPersona({ payload: { jsonparameters } }) {
  try {
    const response = yield call(put_From_PersonaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(putControlEscolarPutPersonaFail(response.Mensaje_Detalle))
    } else {
      yield put(putControlEscolarPutPersonaSuccess(response.Datos))
    }
  } catch (error) {
    yield put(putControlEscolarPutPersonaFail(error))
  }
}
function* fetchGetPersona({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_PersonaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getControlEscolarGetPersonaFail(response.Mensaje_Detalle))
    } else {
      yield put(getControlEscolarGetPersonaSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getControlEscolarGetPersonaFail(error))
  }
}
function* fetchAlumnosList({ payload: { jsonparameters } }) {
  try {
    //
    const response = yield call(getListaAlumnos, jsonparameters)
    //console.log("fetchAlumnosList", response)
    yield put(getControlEscolarListaAlumnosSuccess(response))
    //
  } catch (error) {
    //
    //console.log("Eror: " + error)
    yield put(getControlEscolarListaAlumnosFail(error))

    //
  }
}
function* fetchGetAlumno({ payload: { jsonparameters } }) {
  try {
    const response = yield call(
      get_From_ControlEscolarController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getControlEscolarGetAlumnoFail(response.Mensaje_Detalle))
    } else {
      yield put(getControlEscolarGetAlumnoSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getControlEscolarGetAlumnoFail(error))
  }
}
function* fetchGetEmail({ payload: { jsonparameters } }) {
  try {
    const response = yield call(
      get_From_ControlEscolarController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getControlEscolarGetEmailFail(response.Mensaje_Detalle))
    } else {
      yield put(getControlEscolarGetEmailSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getControlEscolarGetEmailFail(error))
  }
}
function* fetchGetCurp({ payload: { jsonparameters } }) {
  try {
    const response = yield call(
      get_From_ControlEscolarController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getControlEscolarGetCurpFail(response.Mensaje_Detalle))
    } else {
      yield put(getControlEscolarGetCurpSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getControlEscolarGetCurpFail(error))
  }
}
function* fetchGetDescuentos({ payload: { jsonparameters } }) {
  console.log("fetchGetDescuentos")
  try {
    const response = yield call(
      get_From_ControlEscolarController,
      jsonparameters
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(
        getControlEscolarDescuentosInscripcionFail(response.Mensaje_Detalle)
      )
    } else {
      yield put(getControlEscolarDescuentosInscripcionSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getControlEscolarDescuentosInscripcionFail(error))
  }
}
function* fetchCreateAlumno({ payload: { jsonparameters } }) {
  try {
    const response = yield call(post_To_AlumnoController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(postControlEscolarCreateAlumnoFail(response.Mensaje_Detalle))
    } else {
      yield put(postControlEscolarCreateAlumnoSuccess(response.Datos))
      yield put(setControlEscolarResponseParametros(response.Parametros))
    }
  } catch (error) {
    yield put(postControlEscolarCreateAlumnoFail(error))
  }
}

function* ControlEscolarSaga() {
  yield takeEvery(CONTROLESCOLAR_LISTA_ALUMNOS, fetchAlumnosList)
  yield takeEvery(CONTROLESCOLAR_GET_PERSONA, fetchGetPersona)
  yield takeEvery(CONTROLESCOLAR_PUT_PERSONA, fetchPutPersona)
  yield takeEvery(CONTROLESCOLAR_SEND_PASSWORD, fetchSendPassword)
  yield takeEvery(CONTROLESCOLAR_POST_PHOTO, fetchPostPhoto)
  yield takeEvery(CONTROLESCOLAR_PUT_ODIRECCION, fetchPutoDireccion)
  yield takeEvery(CONTROLESCOLAR_GET_ALUMNO, fetchGetAlumno)
  yield takeEvery(CONTROLESCOLAR_PUT_ALUMNO, fetchPutAlumno)
  yield takeEvery(CONTROLESCOLAR_GET_EMAIL, fetchGetEmail)
  yield takeEvery(CONTROLESCOLAR_GET_CURP, fetchGetCurp)
  yield takeEvery(CONTROLESCOLAR_GET_DESCUENTOS_INSCRIPCION, fetchGetDescuentos)
  yield takeEvery(CONTROLESCOLAR_CREATE_ALUMNO, fetchCreateAlumno)
}

export default ControlEscolarSaga
